
<ng-container *ngIf="showFilter && withAccordion; else withoutAcordion">
  <ngb-accordion [activeIds]="panelName">
    <ngb-panel id="custom-panel-1">

      <ng-template ngbPanelHeader let-opened="opened">
        <div class="card-header-body enhanced-filter-header" [class.panel-opened]="opened">
          <button ngbPanelToggle class="filter-header-btn">
            <span class="card-header-title">{{title}}</span>
            <span class="filter-count-badge" [ngClass]="{'double-digit': filterCount >= 10}" *ngIf="filterCount > 0">{{filterCount}}</span>
          </button>
          <button ngbPanelToggle class="btn btn-link p-0 chevron-btn">
            <ng-icon [name]="opened ? 'tablerChevronUp' : 'tablerChevronDown'"></ng-icon>
          </button>
        </div>
      </ng-template>

      <ng-template ngbPanelContent>
        <ng-container *ngTemplateOutlet="withoutAcordion"></ng-container>

      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</ng-container>


<ng-template #withoutAcordion>
  <div class="col-sm-12" style="overflow-y: scroll !important; overflow-x: hidden !important;"  [alwaysCallback]="true"
  infiniteScroll [infiniteScrollThrottle]="300" [scrollWindow]="false" (scrolled)="onScrollDown()" [infiniteScrollDistance]="4"
  [ngStyle]=" withAccordion ?
  {
    'height' : '200px'
  } : filterArr?.length > 5 ? {
    'height' : '300px'
  } : {
    'height' : 'fit-content'
  }">

    <div class="row">

      <div class="p-0 mt-1 col-sm-12"  >
        <!-- [ngClass]="withAccordion ? 'col-sm-6' : 'col-sm-12'" -->
        <div class="gs-search-box gs-search-box--filter">
          <span class="job-search-svg-icon">
            <ng-icon name="tablerSearch"></ng-icon>
          </span>
          <input type="text" #Search placeholder="Search {{title}}"
          (keyup)="onSearch(searchValue)" [(ngModel)]="searchValue"
          class="input-sm form-control job-cand-searchBox" />

        </div>

      </div>

      <div class="col-sm-12 searchResult" *ngIf="searchResult.length > 0">
          <span>Results by: </span>
          <p style="margin: 0;" *ngFor="let item of searchResult; let isLast = last">
              {{item}}  <span *ngIf="!isLast">,</span>
          </p>
      </div>

    </div>

    <div class="row" [ngClass]="!withAccordion ? 'flexBody' : 'filter-body-template'">

      <!-- Spinner takes priority over the data list and the empty
           state. Without this, if the picker already has previously
           loaded items, the off-toggle / search / scroll spinner would
           never get a chance to render (the items branch would win). -->
      <ng-container *ngIf="isLoading; else dataOrEmpty">
        <div class="col-sm-12 text-center filter-picker-spinner">
          <span class="filter-picker-ring" role="status" aria-label="Loading"></span>
        </div>
      </ng-container>

      <ng-template #dataOrEmpty>
        <ng-container *ngIf="filterArr?.length > 0; else noData">

          <ng-container *ngIf="asyncSearch ; else customSearch">
            <div   *ngFor="let item of filterArr" [ngClass]="withAccordion ? 'col-sm-6' : 'col-sm-12'">
              <div class="custom-checkbox">
                <label class="checkbox-label font-normal">
                  <input (change)="onChange(item)" type="checkbox" [(ngModel)]="item.enabled"/>
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{item[filterKey]}}</p>
                </label>
              </div>
            </div>
          </ng-container>

          <ng-template #customSearch>
            <div *ngFor="let item of filterArr | filterData : filterKey  : searchValue" [ngClass]="withAccordion ? 'col-sm-6' : 'col-sm-12'">
              <div class="custom-checkbox">
                <label class="checkbox-label font-normal">
                  <input (change)="onChange(item)" type="checkbox" [(ngModel)]="item.enabled"/>
                  <span class="checkmark" style="top: -5px"></span>
                  <p class="label-ppp"> {{item[filterKey]}}</p>
                </label>
              </div>
            </div>

            <div class="col-sm-12 text-center" style="margin-top: 4rem;"
            *ngIf="(filterArr | filterData : filterKey  : searchValue)?.length === 0">
              No results found
            </div>
          </ng-template>

        </ng-container>

        <ng-template #noData>
          <div class="col-sm-12 text-center" style="margin-top: 4rem;">
                No results found
          </div>
        </ng-template>
      </ng-template>

      <!-- Pagination spinner. Sits at the BOTTOM of the list (not replacing
           it) so scrolling to load the next page keeps the current rows and
           scroll position instead of snapping back to the top. -->
      <div class="col-sm-12 text-center filter-picker-spinner" *ngIf="loadingMore && !isLoading">
        <span class="filter-picker-ring" role="status" aria-label="Loading more"></span>
      </div>

    </div>

  </div>
</ng-template>







